import { KATANA_PERPS } from '#/config/constants';
import {
  softwareWeb3Wallets,
  WalletType,
} from '#/reduxState/wallet/walletUtils';

export interface MenuTypeCore {
  title: string;
  wallet: WalletType;
  /** EIP-6963 Discovered wallet identifier(s) */
  rdns?: string[];
  /** Website of wallet */
  website?: string;
  mobileOnly?: boolean;
}

const softwareWeb3Wallet = (
  title: string,
  walletType: (typeof softwareWeb3Wallets)[number]
): MenuTypeCore => ({
  title,
  wallet: walletType,
});

export const walletsMap: {
  [key in Exclude<WalletType, 'delegatedKey'>]: MenuTypeCore;
} = {
  privateKey: {
    title: 'Private Key',
    wallet: 'privateKey',
  },
  softwareDiscovered_metaMask: {
    title: 'MetaMask',
    wallet: 'softwareDiscovered_metaMask',
    rdns: ['io.metamask', 'io.metamask.mobile'],
    website: 'https://metamask.io/',
  },
  softwareDiscovered_trustWallet: {
    title: 'TrustWallet',
    wallet: 'softwareDiscovered_trustWallet',
    rdns: ['com.trustwallet.app'],
    website: 'https://trustwallet.com/',
  },
  softwareDiscovered: {
    title: '',
    wallet: 'softwareDiscovered',
  },
  keystore: {
    title: 'Keystore File',
    wallet: 'keystore',
  },
  softwareWeb3: softwareWeb3Wallet('Software Wallet', 'softwareWeb3'),
  coinbaseWallet: {
    title: 'Coinbase Wallet',
    wallet: 'coinbaseWallet',
    rdns: ['com.coinbase.wallet'],
  },
  qrSynced: {
    title: `${KATANA_PERPS} Connect`,
    wallet: 'qrSynced',
    mobileOnly: true,
  },
  walletConnect: {
    title: 'WalletConnect',
    wallet: 'walletConnect',
    // render: renderParams => (
    //   <UnlockWalletConnect
    //     onUnlock={async publicKey => {
    //       const wallet = {
    //         walletType: 'walletConnect',
    //         walletAddress: publicKey.toLowerCase(),
    //         walletAddressOriginal: publicKey,
    //       } as const;
    //       return handleUnlock(wallet, renderParams);
    //     }}
    //   />
    // ),
  },
  // ledger: {
  //   title: 'Ledger',
  //   wallet: 'ledger',
  //   // subTitle: (
  //   //   <span>
  //   //     <Link href={urls.ledgerBuyLink}>Buy Here</Link>
  //   //   </span>
  //   // ),
  // },
  // trezor: {
  //   title: 'Trezor',
  //   wallet: 'trezor',
  // },
};

export const walletsList: MenuTypeCore[] = [
  walletsMap.softwareDiscovered_metaMask,
  walletsMap.softwareDiscovered_trustWallet,
  walletsMap.walletConnect,
  walletsMap.coinbaseWallet,
  walletsMap.qrSynced,

  // + All other discovered wallets...
  walletsMap.softwareDiscovered,

  // Hardware wallets removed, April 2022, P9-3096
  // walletsMap.ledger,
  // walletsMap.trezor,
  // Removed, May 2023
  // walletsMap.keystore,
  // walletsMap.privateKey,
];
